<template>
	<div id="LoadingSpinner" class="loading-loader">
		<h6>Shambhala</h6>
		<div class="record-player">
			<i class="record fas fa-compact-disc fa-spin"></i>
			<b class="dial">.</b>
			<b class="dial2">.</b>
			<b class="arm">i</b>
		</div>
		<div class="loading-message loading-dots">Loading</div>
	</div>
</template>

<script>
	export default {
		name: 'LoadingSpinner'
	}
</script>

<style>
	.loading-loader { display: inline-block; opacity: 0.8; padding: 20px 50px; }
	.loading-loader h6 { color: var(--box-header-color) !important; display: block; text-align: center; }
	.record-player { display: block; width: 120px; height: 90px; border: 4px solid var(--box-header-color); border-radius: 3px; position: relative; text-align: left; animation: pulse 1.65s infinite linear; }
	.record-player .record { position: absolute; font-size: 75px; color: var(--box-highlight-color); top: 3px; left: 5px; opacity: 0.6; }
	.record-player .dial { position: absolute; top: -15px; right: 3px; font-size: 70px; vertical-align: bottom; color: var(--box-header-color); font-family: "Arial Rounded MT Bold", "Helvetica Rounded", Arial, sans-serif; }
	.record-player .dial2 { position: absolute; top: 1px; right: 3px; font-size: 70px; vertical-align: bottom; color: var(--box-header-color); font-family: "Arial Rounded MT Bold", "Helvetica Rounded", Arial, sans-serif; }
	.record-player .arm { position: absolute; transform-origin: top right; top: 8px; right: -2px; font-size: 80px; line-height: 80px; vertical-align: bottom; color: var(--box-header-color); transform: rotate(38deg); animation: record-arm 2s infinite linear; text-shadow: 1px 1px 1px rgba(0,0,0,0.4); }
	@keyframes record-arm {
		0% { transform: rotate(38deg); }
		25% { transform: rotate(40deg); }
		75% { transform: rotate(36deg); }
		100% { transform: rotate(38deg); }
	}
	.loading-message { display: block; text-align: left; padding-left: 25px; color: var(--box-highlight-color); font-size: 14px; font-family: sans-serif; margin: 10px; }
	.loading-dots:after { display: inline-block; animation: loading-dots steps(2,end) 2s infinite; content: ''; }
	@keyframes loading-dots {
		0%   { content: '   '; }
		25%  { content: '.  '; }
		50%  { content: '.. '; }
		75%  { content: '...'; }
		100% { content: '   '; }
	}
	@keyframes pulse {
		0%   { transform: scale(1); }
		25%  { transform: scale(0.985); }
		75%  { transform: scale(1.015); }
		100% { transform: scale(1); }
	}
</style>